import React, { ReactElement, memo } from "react";

interface RightArrowProps {
    width?: number;
    height?: number;
    color?: string;
    className?: string;
    strokeWidth?: number;
    onClick?: (e: React.MouseEvent) => void;
}

const RUSTY_ORANGE_COLOR = "#EE4B5E";

const RightArrow = (props: RightArrowProps): ReactElement => {
    const { width = 10, height = 10, color = RUSTY_ORANGE_COLOR, className = "", strokeWidth = 1.5, onClick } = props;
    return (
        <svg
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            preserveAspectRatio="none"
            onClick={onClick}
            className={className}
            fill="none"
        >
            <path
                d="M1 9L5 5L1 1"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default memo(RightArrow);
